import { render } from "./CourseDetails.vue?vue&type=template&id=df6168c2"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/codehat-academy-front-vue3/codehat-academy-front-vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__